// 后台无附件时返回仅含关联信息的占位记录；本地待上传文件也属于有效展示项。
export function isAttachmentPlaceholder(file) {
  return !file || (typeof file === 'object' && !file.fileUrl && !file.filePrefix &&
    !file.url && !file.path && !file.raw && !file.fileName && !file.name)
}

export function attachmentFiles(files) {
  return Array.isArray(files) ? files.filter(file => !isAttachmentPlaceholder(file)) : []
}
